import { useEffect, useState } from "react";
import { UsersAPI } from "../../api/users";

import { useSchool } from "../../context/SchoolContext";

export default function StaffList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentSchoolId } = useSchool();
  const [newStaff, setNewStaff] = useState({ name: "", role: "users", pin: "" });

  useEffect(() => {
    UsersAPI.list(1) // hardcoded schoolId=1
      .then(setUsers)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  async function handleCreate(e) {
    e.preventDefault();
    try {
      const created = await UsersAPI.create({ ...newStaff, schoolId: currentSchoolId || 1 });
      setUsers([...users, created]);
      setNewStaff({ name: "", pin: "" });
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(id) {
    if (window.confirm("Delete this users member?")) {
      try {
        await UsersAPI.delete(id);
        setUsers(users.filter((s) => s.id !== id));
      } catch (err) {
        setError(err.message);
      }
    }
  }

  if (loading) return <p>Loading users...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Staff</h1>

      <form onSubmit={handleCreate} className="flex gap-2 mb-4">
        <input
          placeholder="Name"
          value={newStaff.name}
          onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          placeholder="PIN"
          value={newStaff.pin}
          onChange={(e) => setNewStaff({ ...newStaff, pin: e.target.value })}
          className="border p-2 rounded"
        />
        <button className="bg-green-600 text-white px-3 py-1 rounded">
          Add
        </button>
      </form>

      <ul>
        {users.map((s) => (
          <li key={s.id} className="border rounded p-2 mb-2 flex justify-between">
            {s.name} ({s.pin})
            <button
              onClick={() => handleDelete(s.id)}
              className="text-red-600 hover:underline"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}